module.exports = __webpack_public_path__ + "img/business-solutions-card2.78daef15.png";